import React from 'react';

export const DesignSystemSvgFilters = (): JSX.Element => (
  <svg
    aria-hidden={true}
    focusable="false"
    width="0"
    height="0"
    style={{
      position: 'absolute',
      width: 0,
      height: 0,
      overflow: 'hidden',
    }}
  >
    <defs>
      <filter
        id="noise"
        x="0%"
        y="0%"
        width="100%"
        height="100%"
        filterUnits="objectBoundingBox"
        colorInterpolationFilters="sRGB"
      >
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.95"
          numOctaves="3"
          seed="8652"
          stitchTiles="stitch"
          result="turbulence"
        />
        <feColorMatrix
          in="turbulence"
          type="matrix"
          values="0 0 0 0 0
                  0 0 0 0 0
                  0 0 0 0 0
                  0 0 0 0.1 0"
          result="noiseAlpha"
        />
        <feBlend in="SourceGraphic" in2="noiseAlpha" mode="overlay" />
      </filter>
    </defs>
  </svg>
);
